export default {
    ssl : {
        title : 'SSL Digital Certificate', 
        common : {
            search : 'Search', 
            element : 'No data found, you can',
            content : 'purchase an SSL certificate',
        },
        index : { 
            searchHolder : 'Enter search content', 
            gotoBuy : 'Purchase Certificate',
            FirstColumn  : 'ID',  
            SecondColumn : 'Order Number',  
            ThirdColumn : 'Certificate',  
            FourthColumn : 'Bound Domains',  
            FifthColumn : 'Validity Period',  
            FifthColumnDesc : 'to',  
            SixthColumn : 'Price ($)',
            SeventhColumn : {
                title : 'Status',
                Expired : 'Expired',
                PendingApplication : 'Pending Application',
                ValidatingApplication : 'Validating Application',
                Issued : 'Issued',
                Unverified : 'Unverified',
                Expiring : 'Expiring',
            },
            ActionList : {
                title : 'Actions',
                Verify : 'Apply for Certificate',
                Download : 'Download',
                Revoke : 'Revoke',
                Rebuy : 'Rebuy',
                View : 'View',
            },
        },
        verifyCertificate : {
            title: 'Verify Certificate',
            FirstStep: 'Enter Application',
            SecondStep: 'Upload Verification Meterial (Optional)',
            FirstColumn  : 'Domains to Bind:',  
            FirstPlaceholder  : 'Only 1 domain can be protected',  
            Required: ' is equired',
            SecondColumn : {
                title : 'Company Type',
                FirstLable : 'Private Individual',
                SecondLable : 'Commercial Enterprise',
                ThirdLable : 'Government Entity',
                FourthLable : 'Non-profit Organization',
            },
            ThirdColumn : 'Company (Entity) Name',  
            FourthColumn : 'Company Phone / E-mail',  
            FifthColumn : "Applicant's Name",  
            SixthColumn : "Department",  
            SeventhColumn : "Applicant's Email Address",
            EighthColumn : "Applicant's Phone",
            EighthPlacehloder: "+(cc) (area code)-(your number)",
            NinthColumn : "Country",  
            TenthColumn : "Province / State",  
            EleventhColumn : "City",  
            TwelfthColumn : "Address",  
            ThirteenthColumn : "Postcode",  
            FourteenthColumn : "Domain Verification Method",  
            FifteenthColumn :  {
                title : 'CSR Generation',
                FirstLable : 'Automatic',
                SecondLable : 'Manual',
                FourthLable : 'CSR content',
                placeholder  : 'Fill the CSR file to be uploaded',  
            },
        },
        verifyCertificateSetp2:{
            FirstColumn  : 'Step 1: You need to download the file template. No template button means no template.',
            SecondColumn : 'Step 2: After printing and filling in, sign your name.',  
            ThirdColumn : 'Step 3: Select the scanned file to upload (PNG/JPG format only and file size no more than 500KB).',  
            FourthColumn : 'Upload Business License',  
            FirstButton: 'Cancel',
            SecondButton: 'Next',
            ThirdButton: 'Previous',
            FourthButton: 'Done',
        },
        view:{
            title : 'View Certificate', 
            SecondTitle: 'Basic Information',
            FirstColumn  : 'User Name:',  
            SecondColumn : 'Main Domain:',  
            ThirdColumn : 'Certificate Type:',  
            FourthColumn : 'Certificate Authority:',  
            FifthColumn : 'Domain Protection Type:',  
            SixthColumn : 'Domain Quantity:',
            SeventhColumn : {
                title : 'Type State:',
                Expired : 'Expired',
                PendingApplication : 'Pending Application',
                ValidatingApplication : 'Validating Application',
                Issued : 'Issued',
                Unverified : 'Unverified',
                Expiring : 'Expiring',
            },
            EighthColumn : "Price:",
            NinthColumn : "Validity Period:",  
            ApplicantList : {
                title : 'Applicant Information', 
                FirstColumn : 'Business License',  
                SecondColumn: 'Organization Department',
                ThirdColumn: 'Domain List',
            },
            viaList:{
                viaDNS: 'via DNS',
                viaFile: 'via File',
            },
        },
        error : {
            renewpop:{
                error1 : 'Please enter the login password',
                error2 : 'Please wait for the price calculate out',
                error3 : 'Period must great than 0',
                error4 : 'Please select at least 1 instance',
            },
            startpop:{
                error1 : 'One or more instances can not be start',
            },
            restartpop:{
                error1 : 'One or more instances can not be restart',
            },
            stoppop:{
                error1 : 'One or more instances can not be stop',
            },
            buypop:{
                error1 : 'Please enter the login password',
                error2 : 'Create order fail!',
                error3 : 'Please select payment method!',
            },
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/en/ssl.js